import React from 'react'
import Image from '../../components/App/LazyImage'

const UsPurchaseOnly = () => {

    return (
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'10px'}}>
        <div style={{marginRight:'10px'}}>
            <Image
                src={
                    'https://d2kn7nb9ubajli.cloudfront.net/assets/us-flag-icon.png'
                }
                alt={`United States flag icon`}
                width={'19'}
                height={'11'}
            />
            </div>
        <div style={{fontSize:16}}>For U.S. purchase and use only.</div>
    </div>   
    )
}

export default UsPurchaseOnly; 